import * as am4core from "@amcharts/amcharts4/core";

export const colors = [
  "#FBC658", //talkwalker
  "#51BCDA", //insights
  "#6C757D",
  "#FF6426", //all (red)
  "#6BD098", //lexisnexisx
  '#fc5c65',
  '#fd9644',
  '#fed330',
  '#26de81',
  '#2bcbba',
  '#eb3b5a',
  '#fa8231',
  '#f7b731',
  '#20bf6b',
  '#0fb9b1',
  '#45aaf2',
  '#4b7bec',
  '#a55eea',
  '#d1d8e0',
  '#778ca3',
  '#2d98da',
  '#3867d6',
  '#8854d0',
  '#a5b1c2',
  '#4b6584'
];

export default function am4themes_myTheme(target) {
  if (target instanceof am4core.ColorSet) {
    for (let i = 0; i < colors.length; i++) {
      target.list.push(am4core.color(colors[i]));
    }
  }
}
